import { useTranslation } from "react-i18next";

import { Button } from "@primitives/button";
import { cn } from "@lib/utils";

import { BFN_AVAILABLE } from "@/config/bfnConfig";
import { useBfnCalculatorState } from "@/zustand/BfnCalculatorState";
import { PolymathMark } from "@/components/shared/icons/ArchitectMark";

/**
 * Navbar entry point for the BFN Calculator. Follows the Architect button
 * precedent but is fully hidden while the feature flag is off (default), so it
 * is invisible to real users until VITE_BFN_ENABLED is flipped on staging.
 *
 * Entitlement is NOT gated here — the button opens the view for any logged-in
 * user, and the view's token exchange decides access (403 → upsell). This
 * avoids gating in the FE on subscription data the FE cannot see (trial state).
 */
export default function BfnCalculatorNavButton() {
  const { t } = useTranslation();
  const openCalculator = useBfnCalculatorState((state) => state.open);
  const isOpen = useBfnCalculatorState((state) => state.isOpen);

  // Fail-closed: BFN_AVAILABLE requires both the flag AND a valid gateway origin.
  if (!BFN_AVAILABLE) {
    return null;
  }

  return (
    <li className="grow lg:grow-0">
      <Button
        onClick={() => openCalculator()}
        size="icon"
        variant="ghost"
        aria-label={t("bfn.openCalculator")}
        className={cn(
          "relative mx-auto flex h-10 w-10 items-center justify-center rounded-xl hover:bg-transparent",
          isOpen &&
            "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground",
        )}
      >
        <PolymathMark className="size-7" />
      </Button>
    </li>
  );
}
